import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';

const getQueryParams = (lang: string) => {
	if (typeof window !== 'undefined') {
		const url = new URL(window.location.href);
		url.searchParams.set('culture', lang);

		return url.searchParams.toString();
	}

	return `culture=${lang}`;
};

export const getGenericEndpoint = async <T>(
	path: string,
	lang = 'en',
	isApiPath = true
) => {
	const queryParams = getQueryParams(lang);

	const baseUrl = isApiPath
		? `${PUBLIC_IDM_API_URL_ENV}/api`
		: PUBLIC_IDM_API_URL_ENV;

	return fetch(`${baseUrl}/${path}?${queryParams}`, {
		method: 'GET',
		credentials: 'include',
	})
		.then((res) => {
			if (res.ok) return res.json() as Promise<T>;
		})
		.catch((error) => {
			console.error(`GET /${path} request error:`, error);
			throw error;
		});
};
